import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'; 
import { CommonModuleModule } from '../common-module/common-module.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
 import { AuthGuard } from '../common-service/auth-gurd.guard';
import { EditDetailComponent } from './edit-detail/edit-detail.component';
import { ViewDetailsComponent } from './view-details/view-details.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { PtrPaymentReceiptComponent } from './ptr-payment-receipt/ptr-payment-receipt.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { CreateAgendaComponent } from '../common-module/create-agenda/create-agenda.component';
import { CollegeInstitutionDashboardComponent } from './college-institution-dashboard/college-institution-dashboard.component';
  
export const ptrChekerRouter: Routes = [
  { path: 'dashboard/:paymentCode', component: CollegeInstitutionDashboardComponent, canActivate: [AuthGuard] },
  { path: 'editPTR/:id', component: EditDetailComponent,canActivate: [AuthGuard] },
  { path: 'viewPTR/:id', component: ViewDetailsComponent,canActivate: [AuthGuard] },
  { path: 'paymentReceipt/:id', component: PtrPaymentReceiptComponent,canActivate: [AuthGuard] },
  { path: 'internal/createAgenda/:registrationId', component: CreateAgendaComponent,canActivate: [AuthGuard] },
  
  {
    path: 'sectionExcutive',
    loadChildren: () => import('./section-excutive/section-excutive.module').then(se => se.SectionExcutiveModule),
  },
  {
    path: 'sectionHead',
    loadChildren: () => import('./section-head/section-head.module').then(sh => sh.SectionHeadModule),
  },
  {
    path: 'ptrCommon',
    loadChildren: () => import('./ptr-common/ptr-common.module').then(pc => pc.PtrCommonModule),
  }, 

]

@NgModule({
  imports: [
    CommonModule,CKEditorModule,
    ReactiveFormsModule, FormsModule, NgbModule, CommonModuleModule, 
    RouterModule.forChild(ptrChekerRouter),HttpClientModule,
    NgxDaterangepickerMd.forRoot()
  ],
  declarations: [EditDetailComponent, CollegeInstitutionDashboardComponent]
})
export class PtrModule { }


